var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideTopBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 270,
    viewBox: "0 0 560 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10348_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.5 0C296.6 19.6 297 42.5 307.6 62.7C326.8 99.1 371.8 113 408.1 93.8C442.2 75.8 456.6 35 442.4 0L304.5 0Z",
    fill: "url(#paint0_linear_10348_179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.3 0C467.9 3.5 469 7 470.8 10.3C479.6 26.9 500.2 33.3 516.8 24.5C526.6 19.3 532.8 10.1 534.5 0H467.3Z",
    fill: "#C3232E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.8 31C545.3 32.6 530.8 36.9 517.1 44.2C458.3 75.2 435.8 148 466.8 206.8C486.1 243.4 521.6 265.9 559.8 270.3V31Z",
    fill: "url(#paint1_linear_10348_179)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10348_179",
    x1: 421.3,
    y1: 81.7,
    x2: 322,
    y2: -21.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10348_179",
    x1: 667.5,
    y1: 69.2,
    x2: 473,
    y2: 201.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA213"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10348_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 270,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideTopBg);
export default __webpack_public_path__ + "static/media/asideTopBG.1c34947fe7889e848a5c38200f4c82fe.svg";
export { ForwardRef as ReactComponent };